<template>
  <div class="account-type-container">
    <!-- Header -->
    <div class="account-type-header">
      <div class="account-type-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h1 class="account-type-title">Choose your product</h1>
      <p class="account-type-subtitle">
        Select the feature that best fits your needs. You can always add more from your dashboard.
      </p>
    </div>

    <!-- Cards -->
    <AccountTypeForm class="account-type-cards" />

    <!-- Footer -->
    <div class="account-type-footer">
      <span class="account-type-footer__text">Already have an account?</span>
      <router-link :to="{ name: 'SignIn' }" class="account-type-footer__link">
        Sign in
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AccountTypeForm from "@/components/onboarding/forms/AccountTypeForm.vue";

export default {
  name: "AccountType",

  components: { AccountTypeForm },
};
</script>

<style lang="scss" scoped>
.account-type-container {
  width: 100%;
  max-width: 800px;
  padding: 0 16px 40px;
}

.account-type-header {
  text-align: center;
  margin-bottom: 40px;
}

.account-type-icon {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #EBF2FF 0%, #F0F6FF 100%);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4D84FF;
  margin: 0 auto 20px;
}

.account-type-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: #0F172A;
  margin: 0 0 12px 0;
  letter-spacing: -0.02em;
}

.account-type-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: #64748B;
  margin: 0;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
}

.account-type-cards {
  margin-bottom: 32px;
}

.account-type-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  &__text {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #64748B;
  }

  &__link {
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #4D84FF;
    text-decoration: none;
    transition: color 0.15s ease;

    &:hover {
      color: #3B6FE8;
    }
  }
}
</style>
